<template>
  <div class="info-box input-porting-consent">
    <slot name="headlineNumberPortingConsent"></slot>
    <b-form-group class="checkbox-group mt-2 mandatory" :class="vflowGetFeedbackClasses('selectedNumberPortingConsent', 'checked')">
      <b-form-checkbox :class="['mt-0']"
            id="consentPortability"
            name="consentPortability"
            v-model="selectedNumberPortingConsent"
            class="agb-information-article-checkbox"
            required
            @input="$v.selectedNumberPortingConsent.$touch; vflowInputFocused('selectedNumberPortingConsent');"
            @click="$v.selectedNumberPortingConsent.$touch; vflowInputFocused('selectedNumberPortingConsent');"
            @change="$v.selectedNumberPortingConsent.$touch; vflowInputFocused('selectedNumberPortingConsent');"
            >
          <span><slot name="txtNumberPorting"></slot></span>
          <b-form-invalid-feedback>
            <slot name="txtConfirmationRequired">Dies ist ein Pflichtfeld.</slot>
          </b-form-invalid-feedback>
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'ConsultationConsent',
  data () {
    return {
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('selectedNumberPortingConsentProp', 'selectedNumberPortingConsent'),
    syncProperty('invalid', 'invalid_'),
    validationFlow
  ],
  mounted () {
    this.$v.$touch()
    this.invalid_ = this.$v.$invalid
  },
  methods: {
    validateForm: function () {
      this.vflowForceFeedback()
    }
  },
  watch: {
    // this event will be triggered when the complete/form validation changed (not on every field validation change)
    '$v.$invalid': function (v) {
      this.invalid_ = v
      this.$emit('update:mnpin-porting-validation', v)
    }
  },
  validations () {
    return {
      selectedNumberPortingConsent: {
        checked (v) {
          return (true && v)
        }
      }
    }
  }
}
</script>
